module.exports = __webpack_public_path__ + "media/images/burger-d2411febe51306c923560867b2133955.png";